"use strict";

module.exports = /* @ngInject */ function() {
  return {
    require: "rtOptionsProvider",
    link: (scope, element, attributes, rtOptionsProviderController) => {
      const options = [
        { text: "REDI", value: "REDI" },
        { text: "Bloomberg ID", value: "BLOOMBERG_ID" },
        { text: "RIC", value: "RIC" },
        { text: "SEDOL", value: "SEDOL" }
      ];
      rtOptionsProviderController.setOptions(options);
    }
  };
};



// WEBPACK FOOTER //
// ./app/ui/directives/rtGlobalSettings/rtSymbologyOptionsProvider.js